import { render, staticRenderFns } from "./AlbaPanel.vue?vue&type=template&id=4021cf18"
import script from "./AlbaPanel.vue?vue&type=script&lang=js"
export * from "./AlbaPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports